/**
 * Copyright 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import React, { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import Popup from "react-popup";
import { ROUTES } from "../../../routes/routes";

interface Props {
  children: ReactNode;
}

export const SettingsPageLayout: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <div className="main wide">
      <div className="container is-fluid">
        <div className="box">
          <div className="tabs is-toggle">
            <ul>
              <li>
                <Link
                  className={`${
                    (path.includes(ROUTES.settings.profile.index.generate()) ||
                      path === ROUTES.settings.index.generate()) &&
                    "active"
                  }`}
                  to={ROUTES.settings.profile.index.generate()}
                >
                  Profile
                </Link>
              </li>
              <li>
                <Link
                  className={`${
                    path.includes(
                      ROUTES.settings.notificationGroups.index.generate()
                    ) && "active"
                  }`}
                  to={ROUTES.settings.notificationGroups.index.generate()}
                >
                  Notification Groups
                </Link>
              </li>
              <li>
                <Link
                  className={`${
                    path.includes(ROUTES.settings.setups.index.generate()) &&
                    "active"
                  }`}
                  to={ROUTES.settings.setups.index.generate()}
                >
                  Setups
                </Link>
              </li>
              <li>
                <Link
                  className={`${
                    path.includes(ROUTES.settings.policies.index.generate()) &&
                    "active"
                  }`}
                  to={ROUTES.settings.policies.index.generate()}
                >
                  Policies
                </Link>
              </li>
              <li>
                <Link
                  className={`${
                    path.includes(ROUTES.settings.tags.index.generate()) &&
                    "active"
                  }`}
                  to={ROUTES.settings.tags.index.generate()}
                >
                  Tags
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {children}
        <Popup />
      </div>
    </div>
  );
};
